import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GeneralRoutePaths } from '../../core/enums/route-types.enum';
import { UserService } from '../../core/services/user/user.service';
import { LoaderComponent } from '../../ui-elements/loader/loader.component';
import { UpdateService } from '../../update.service';

@Component({
  selector: 'app-page-not-allowed',
  templateUrl: './page-not-allowed.component.html',
  styleUrls: ['../errors.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, LoaderComponent],
})
export class PageNotAllowedComponent implements OnInit, OnDestroy {
  private swUpdate = inject(SwUpdate);
  private updateService = inject(UpdateService);
  private userService = inject(UserService);

  updateAvailable = false;
  isNspaceAdmin = false;
  sonataUrl = `/${GeneralRoutePaths.SONATA}`;
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.isNspaceAdmin = this.userService.isNspaceAdmin();

    if (this.swUpdate.isEnabled) {
      this.subscriptions.add(
        this.updateService.getUpdateDownloadingAsObservable().subscribe((updateDownloading) => {
          // force reload when downloading update state changes from true to false - app has been updated
          if (this.updateAvailable && !updateDownloading) {
            this.reload();
            return;
          }

          this.updateAvailable = updateDownloading;
        }),
      );
    }
  }

  reload() {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
